import React from "react";
import Svg from "_assets/svg";
import Button from "./Button";
import Chevron from "./Chevron";

const PageButton = (props) => {
  const { onPrevClick, onNextClick, disabledLeft, disabledRight } = props;
  return (
    <div className="d-flex flex-row align-items-center">
      <Button
        className="d-flex align-items-center justify-content-center margin-right-15"
        disabled={disabledLeft}
        onClick={onPrevClick}
      >
        <Chevron src={Svg.chevron.default} left />
      </Button>
      <Button
        className="d-flex align-items-center justify-content-center"
        disabled={disabledRight}
        onClick={onNextClick}
      >
        <Chevron src={Svg.chevron.default} />
      </Button>
    </div>
  );
};

export default PageButton;
